<script setup lang="ts" generic="T">
import { FormKitLazyProvider } from '@formkit/vue'
import type { SectionsSearchFormColumnsGroup } from '@autobid/strapi-integration/rest/components'
import type { FormKitSchemaFormKit } from '@formkit/core'
import type { Raw } from 'vue'
import { FormKitSchema } from '@formkit/vue'
import SearchFormChipsMobile from './chips/SearchFormChipsMobile.vue'

const props = defineProps<{
  form: NonNullable<SectionsSearchFormColumnsGroup['forms']>[number]
  library: Raw<T>
}>()

function createTitle() {
  return (props.form.formSchema as FormKitSchemaFormKit[]).map(item => Object.values(item)[0]).join('-')
}

provide('title', props.form.title ?? createTitle())
</script>

<template>
  
<FormKitLazyProvider config-file="true">
<div
    :key="form.formSchema.toString()"
    :class="`form-${form.width.split('-')[1].replace('/', '_')}`"
    class="container relative flex w-full max-w-[100vw] flex-col gap-4 bg-gray-100"
  >
    <p
      v-if="form.title"
      class="break-all pb-4 pt-2 text-2xl font-semibold uppercase text-primary"
    >
      {{ form.title }}
    </p>
    <div class="grid grid-cols-12 gap-4 overflow-x-auto p-4 md:p-8">
      <!-- @vue-expect-error -->
      <FormKitSchema :schema="form.formSchema" :library="library" />
    </div>
  </div>
  <SearchFormChipsMobile class="col-span-12" />
</FormKitLazyProvider>

</template>
